<template>
  <div class="announcement-box">
    <div class="announcement-ul">
      <div class="announcement-li" v-for="(item, index) in announcement" :key="index" @click="onClickRoute(item.id)">
        <div class="announcement-left">
          <div class="announcement-top">{{ item.createTime.slice(4, 6) }}-{{ item.createTime.slice(6, 8) }}</div>
          <div class="announcement-bottom">{{ showTime(item.createTime, 'year', '.') }}</div>
        </div>
        <div class="announcement-right">
          <div class="announcement-title">{{ item.title }}</div>
          <div class="announcement-p">{{ item.introduction }}</div>
        </div>
      </div>
    </div>
    <el-pagination v-if="page.number" class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick"></el-pagination>
  </div>
</template>

<script>
import { getTime } from "@/util/public";
export default {
  name: "index",
  props: {
    // 定义 announcement 为数组类型，必填
    announcement: {
      type: Array,
      required: true,
      default: () => [] // 防止 undefined
    },
    page: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {

    };
  },
  methods: {
    onClickRoute(value) {
      let token = localStorage.getItem("x-token")
      if(token == null) {
        this.$router.push({ path: `/codeLogin` });
        return
      }
      this.$router.push({ path: `/QualityControlDetails/${value}` }); // 动态路由传递课程 id
    },
    showTime(value, type, separation) {
      return getTime(value, type, separation)
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  },
  mounted() {

  }
};
</script>

<style scoped lang="less">
.qualityControl-box {
  .announcement-box {
    padding: 20px 20px;
    background: #fff;
    margin-top: 20px;
  }

  .announcement-ul {
    margin-top: 0;
  }

  .paging {
    display: block;
  }
}

.paging {
  display: none;
}

.announcement-box {
  width: 100%;
}

.announcement-ul {
  margin-top: 20px;
  width: 100%;

  .announcement-li:last-child {
    margin-bottom: 0;
  }

  .announcement-li:hover {
    .announcement-title {
      color: #a41218 !important;
    }
  }

  .announcement-li {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    cursor: pointer;

    .announcement-left:before {
      content: '';
      display: block;
      position: absolute;
      width: calc(100% - 6px);
      height: 2px;
      background: rgba(254, 189, 88, 1);
      left: 3px;
      top: 0;
    }

    .announcement-left {
      width: 80px;
      height: 80px;
      border: 1px solid rgba(225, 225, 225, 1);
      position: relative;

      .announcement-top:before {
        content: '';
        display: block;
        position: absolute;
        width: 0;
        height: 0;
        border-top: 8px solid rgba(254, 189, 88, 1);
        border-right: 8px solid transparent;
        border-left: 8px solid transparent;
        border-bottom: 8px solid transparent;
        top: 0;
        left: calc(50% - 7px);
      }

      .announcement-top {
        color: rgba(38, 38, 38, 1);
        font-size: 20px;
        font-weight: bold;
        line-height: 50px;
      }

      .announcement-bottom {
        background: rgba(164, 18, 24, 1);
        color: #fff;
        line-height: 30px;
        font-size: 16px;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
      }
    }

    .announcement-right {
      width: calc(100% - 92px);
      margin-left: 12px;
      text-align: left;

      .announcement-title {
        color: rgba(38, 38, 38, 1);
        font-size: 16px;
        line-height: 24px;
        font-weight: bold;
        -webkit-box-orient: vertical;
        /* 子元素垂直排列 */
        -webkit-line-clamp: 2;
        /* 最多显示 2 行 */
        overflow: hidden;
        /* 超出隐藏 */
        text-overflow: ellipsis;
        /* 超出部分显示省略号 */
      }

      .announcement-p {
        white-space: nowrap;
        /* 禁止换行 */
        overflow: hidden;
        /* 超出隐藏 */
        text-overflow: ellipsis;
        /* 超出部分显示省略号 */
        font-size: 15px;
        line-height: 28px;
        color: rgba(115, 115, 115, 1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/announcement/index.vue